import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from '@99designs/react-components/components/Icon';
import ButtonGroup, { ButtonGroupItem } from '@99designs/react-components/components/ButtonGroup';
import MarketingIcon from 'contest/components/marketing-icon';
import {
    ContentListingItem,
    ContentListingItemImage,
    ContentListingItemActions,
    ContentListingItemDetailsActionsWrapper,
    ContentListingItemDetails,
} from 'contest/components/content-listing';

export default class Deliverable extends React.Component {
    renderLink(uri, icon, message_id) {
        if (uri) {
            return (
                <ButtonGroupItem>
                    <Icon variations={[icon]} />{' '}
                    <a href={uri} className="link">
                        <FormattedMessage id={message_id} />
                    </a>
                </ButtonGroupItem>
            );
        }
    }

    renderLinks() {
        const deliverable = this.props.deliverable;
        if (this.props.showLinks) {
            return (
                <ContentListingItemActions>
                    <ButtonGroup variations={['responsive']}>
                        {this.renderLink(
                            deliverable.articleUri,
                            'design-1',
                            'brief_deliverables_design_guideline_link'
                        )}
                        {this.renderLink(
                            deliverable.videoUri,
                            'play-1',
                            'brief_deliverables_how_to_video_link'
                        )}
                        {this.renderLink(
                            deliverable.templateUri,
                            'download-1',
                            'brief_deliverables_template_link'
                        )}
                    </ButtonGroup>
                </ContentListingItemActions>
            );
        }
    }

    render() {
        const deliverable = this.props.deliverable;
        const title = deliverable.metadata.title || deliverable.name;
        const quantity = deliverable.metadata.quantity ? deliverable.metadata.quantity + ' x ' : '';
        return (
            <ContentListingItem variations={['single-borderless']}>
                <ContentListingItemImage>
                    <MarketingIcon variations={[deliverable.icon]} />
                </ContentListingItemImage>

                <ContentListingItemDetailsActionsWrapper>
                    <ContentListingItemDetails>
                        <h4 className="content-listing-details__title">
                            {quantity} {title}
                        </h4>
                    </ContentListingItemDetails>
                    {this.renderLinks(deliverable)}
                </ContentListingItemDetailsActionsWrapper>
            </ContentListingItem>
        );
    }
}

Deliverable.propTypes = {
    deliverable: PropTypes.shape({
        name: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,

        templateUri: PropTypes.string,
        articleUri: PropTypes.string,
        videoUri: PropTypes.string,

        metadata: PropTypes.object,
    }),
    showLinks: PropTypes.bool,
};

Deliverable.defaultProps = {
    showLinks: false,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/deliverable.jsx